/**
 * Copyright © 2026 Adnuntius AS.
 */
import {visiblePageNumbers} from '../../common/directives/pagination/visible-page-numbers';

export interface WorkspaceListColumn {
  param: string;
  label?: string;
  labelInstant?: string;
  numeric?: boolean;
}

export function isWorkspaceColumnSortable(column: WorkspaceListColumn): boolean {
  return !!column.param;
}

export function workspaceColumnLabel(column: WorkspaceListColumn): string {
  if (column.labelInstant) {
    return column.labelInstant;
  }
  const key = column.label || column.param;
  return key ? 'label.' + key : '';
}

export function workspaceSortBy(list: any, column: WorkspaceListColumn): void {
  if (!isWorkspaceColumnSortable(column) || !list?.makeSortQuery) {
    return;
  }
  if (column.numeric) {
    list.makeSortQuery(column.param, column.numeric);
  } else {
    list.makeSortQuery(column.param);
  }
}

export function workspaceChangePage(list: any, page: number): void {
  if (!list || page < 1 || page > workspaceTotalPages(list) || page === list.currentPage) {
    return;
  }
  list.currentPage = page;
  list.changePage();
}

export function workspaceTotalPages(list: any): number {
  return Math.max(1, Math.ceil((list?.totalCount || 0) / (list?.pageSize || 1)));
}

export function workspacePageNumbers(list: any): number[] {
  return visiblePageNumbers(list?.currentPage || 1, workspaceTotalPages(list));
}

export function workspacePageRangeStart(list: any): number {
  return list.pageSize * (list.currentPage - 1) + 1;
}

export function workspacePageRangeEnd(list: any): number {
  return Math.min(list.pageSize * list.currentPage, list.totalCount);
}
